import { NgIf, NgFor } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

@Component({
  templateUrl: './cart-snackbar.component.html',
  imports: [NgIf, NgFor, MatButton, AgrI18nSharedModule],
})
export class CartSnackbarComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: string[] = [],
    private readonly _snackBarRef: MatSnackBarRef<CartSnackbarComponent>,
  ) {}

  ngOnInit(): void {
    if (this.data.length === 0) {
      setTimeout(() => this.dismiss(), 5000);
    }
  }

  dismiss() {
    this._snackBarRef.dismiss();
  }
}
